module.exports = __webpack_public_path__ + "img/cloud.bbf47e65.jpg";